import React from 'react'
const bee = require('../assets/LOGO.png')
const phone = require('../assets/icon/phone_white_WEB_CHANGE_6.png')
const mail = require('../assets/icon/mail_white_WEB_CHANGE_6.png')
const gif_flag = require('../assets/flag.gif')

const Footer = () => {

    return (
        <footer>
            <div className="row footer m-0 text-justify">
                <div className="col-md-3 col-sm-12">                    
                    <div className="padd-topbtm-10 mrg-leftright-20">
                        <a href="#"><img src={bee} width="40" /></a>
                    </div>
                    <h5 className="padd-btm"><span className="bee-style rajdhani-bold">BEE</span> <span className="bee-style about-bee-font" style={{ opacity: '0.8' }}>HIVES</span></h5>
                    <div>
                        <p className="m-0">CDC 74, PCNTDA,</p>
                        <p className="m-0">Purnanagar, Chikhli,</p>
                        <p className="m-0">Pune - 411019</p>
                        <p className="m-0">Maharashtra,</p>
                        <p className="m-0">INDIA</p>
                        <p><img src={gif_flag} width="50" className="flag" alt="India"/></p>                      
                    </div>
                </div>
                <div className="col-md-3 col-sm-12">
                    <h5 className="padd-btm">Services</h5>
                    <div>
                        <p className="m-0">New Product Design</p>
                        <p>and Development</p>
                        <p>Reverse Engineering</p>
                        <p className="m-0">Project Support and</p>
                        <p>Consultancy</p>
                        <p>Siemens NX Training</p>
                        <p>Domain Training</p>
                        <p>Staffing Solutions</p>
                    </div>
                </div>
                <div className="col-md-3 col-sm-12">
                    <h5 className="padd-btm">Follow Us</h5>
                    <div className="row padd-btm">
                        <div className="col-xs-2 text-align footer_icon">
                            <a href="https://www.facebook.com/BEEHIVESPRODUCTDESIGN" target="_blank" rel="noopener noreferrer" className="a-tag-color">
                                <i className="fa fa-facebook icon-font-size" aria-hidden="true"></i>
                            </a>
                        </div>
                        <div className="col-xs-2 footer_icon">
                            <a href="https://instagram.com/bee_hives_product_design?igshid=auijqa3s6eyu" target="_blank" rel="noopener noreferrer" className="a-tag-color">
                                <i className="fa fa-instagram icon-font-size" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>

                    <div className="row padd-btm">
                        <div className="col-xs-2 footer_icon">
                            <a href="https://www.linkedin.com/company/bee-hives-product-design-and-engineering-services" target="_blank" rel="noopener noreferrer" className="a-tag-color">
                                <i className="fa fa-linkedin icon-font-size" aria-hidden="true"></i>
                            </a>
                        </div>
                        <div className="col-xs-2 you_tube_padd">
                            <a href="https://www.youtube.com/channel/UC_oGOL5l-GTITBBhUIadbsg/featured?disable_polymer=1" target="_blank" rel="noopener noreferrer" className="a-tag-color">
                                <i className="fa fa-youtube-play icon-font-size" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-md-3 col-sm-12">
                    <h5 className="padd-btm">Contact Us</h5>                    
                    <p><img src={mail} width="20" alt="Email"/>  info@beehives.co.in</p>
                    <p><img src={phone} width="20" alt="Phone"/>+91-8482858740</p>
                </div>
            </div>
        </footer>
    )
}

export default Footer